import { Component, inject, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReportControl } from '@xmedical/core';
import { XmedicalUiModule } from '@xmedical/ui';
import { ReportControlEditorService } from '../../services/report-control-editor.service';

@Component({
  selector: 'xmed-procedure-field-renderer',
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    XmedicalUiModule
  ],
  templateUrl: './procedure-field-renderer.component.html',
  styleUrl: './procedure-field-renderer.component.scss'
})
export class ProcedureFieldRendererComponent {
  private editorService = inject(ReportControlEditorService);

  control = input.required<ReportControl>();

  onValueChanges(): void {
    this.editorService.triggerEvent();
  }
}
